import Button from "@/common/elements/Button";
import Table from "@/common/elements/Table";
import { StyledFlex } from "@/common/styles";
import { PlusOutlined } from "@ant-design/icons";
import SignaturesFormModal from "./SignaturesFormModal";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { Popconfirm } from "antd";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import { getRefListNameByID, isNonEmptyVariable } from "@/util/common_function";
import API_ENDPOINTS from "@/util/api";
import _ from "lodash";
import { hasCheckSecurity } from "@/util/common_function";
import {
  Entity_types,
  Permissions,
  Security_Types,
} from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";
const SignaturesTable = ({}) => {
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );

  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setisEdit] = useState(null);
  const [signatureData, setSignatureData] = useState([]);
  const [selectSignatureData, setSelectSignatureData] = useState(null);
  const [loginUser, setLoginUser] = useState(null);

  useState(() => {
    let user = localStorage.getItem("userDetails");
    if (isNonEmptyVariable(user)) {
      user = JSON.parse(user);
      setLoginUser(user);
    }
  }, []);

  useEffect(() => {
    const signData = [];
    bookings?.bookingSignature?.forEach((sign) => {
      let obj = {
        ...sign,
        uuid: uuidv4(),
        dateAdded: sign?.signature?.[0]?.photos?.[0]?.dateAdded || "",
        timeAdded: sign?.signature?.[0]?.photos?.[0]?.timeAdded || "",
        officer: sign?.signature?.[0]?.photos?.[0]?.user || "",
        signatureReason: sign?.signature?.[0]?.signatureReasonID
          ? getRefListNameByID(
              "Signature_Reason",
              sign?.signature?.[0]?.signatureReasonID
            )
          : "",
      };

      signData.push(obj);
    });

    console.log(signData);

    setSignatureData(signData);
  }, [bookings]);

  const hideModalHandle = () => {
    setisEdit(false);
    setSelectSignatureData(null);
    setShowModal(false);
  };

  const showModalHandle = (action) => {
    if (action === "add") {
      setisEdit(false);
      setSelectSignatureData(() => null);
    }
    setShowModal(true);
  };

  const handleSignSelect = (values) => {
    setisEdit(true);
    setSelectSignatureData(values);
  };

  const handleSave = (values) => {
    let photos = null;
    if (isEdit) {
      const sp = _.cloneDeep(selectSignatureData?.signature?.[0]?.photos?.[0]);
      photos = {
        ...sp,
        ...values?.signature?.[0]?.photos?.[0],
      };
    } else {
      photos = values?.signature?.[0]?.photos?.[0];
    }

    values = {
      ...values,
      signature: [
        {
          ...values?.signature?.[0],
          photos: [
            {
              ...photos,
              user: loginUser?.username,
              creatorStaffId: loginUser?.staffId,
            },
          ],
        },
      ],
    };
    let signature = signatureData || [];
    if (isEdit) {
      signature = signature?.map((s) => {
        if (selectSignatureData?.uuid == s?.uuid) {
          return {
            ...s,
            ...values,
          };
        }

        return s;
      });
    } else {
      signature.push(values);
    }

    dispatch(
      setBookings({
        bookingSignature: signature,
      })
    );

    hideModalHandle();
  };

  const handleDelete = () => {
    let signature = signatureData || [];
    signature = signature?.filter((s) => s?.uuid !== selectSignatureData?.uuid);
    dispatch(
      setBookings({
        bookingSignature: signature,
      })
    );

    if (isNonEmptyVariable(selectSignatureData?.bookingSignatureID)) {
      const url =
        API_ENDPOINTS.signature + "/" + selectSignatureData?.bookingSignatureID;
      dispatch(setDeleteAPis(url));
    }

    setSelectSignatureData(null);
  };

  const cancelAction = () => {
    hideModalHandle();
  };
  return (
    <>
      <StyledFlex justify="end" style={{ marginBottom: "10px" }} gap="10px">
        <Button
          onClick={() => showModalHandle("add")}
          disabled={
            !bookingsFieldsEnabled ||
            !hasCheckSecurity(
              Security_Types.functionality,
              Entity_types.subModule,
              LABELS_CAPITAL.ADD,
              MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
              SUB_MODULES_LIST_WITH_ID.Arrest_Report
            )
          }
        >
          <PlusOutlined /> Add
        </Button>
        <Button
          onClick={() => showModalHandle("edit")}
          disabled={
            !isEdit ||
            !hasCheckSecurity(
              Security_Types.functionality,
              Entity_types.subModule,
              LABELS_CAPITAL.VIEW,
              MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
              SUB_MODULES_LIST_WITH_ID.Arrest_Report
            )
          }
        >
          Details
        </Button>
        <Button
          onClick={() => cancelAction()}
          disabled={!isEdit}
        >
          Cancel
        </Button>
        <Popconfirm
          title="Delete the signature item"
          description="Are you sure to delete this signature?"
          onConfirm={handleDelete}
          onCancel={() => {}}
          okText="Yes"
          cancelText="No"
        >
          <Button
            disabled={
              !isEdit ||
              !bookingsFieldsEnabled ||
              !hasCheckSecurity(
                Security_Types.functionality,
                Entity_types.subModule,
                LABELS_CAPITAL.DELETE,
                MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                SUB_MODULES_LIST_WITH_ID.Arrest_Report
              )
            }
          >
            {" "}
            Delete{" "}
          </Button>
        </Popconfirm>
      </StyledFlex>
      {hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.VIEW,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Arrest_Report
      ) && (
        <Table
          headers={[
            { key: "dateAdded", text: "Date Added" },
            { key: "timeAdded", text: "Time Added" },
            { key: "officer", text: "Officer" },
            { key: "signatureReason", text: "Signature Reason" },
          ]}
          data={signatureData}
          onRowClick={handleSignSelect}
          selected={selectSignatureData === null}
        />
      )}
      {showModal &&
        hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.VIEW,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Inmate_Property
        ) && (
          <SignaturesFormModal
            show={showModal}
            onHide={hideModalHandle}
            selectSignatureData={selectSignatureData}
            onSave={handleSave}
            isEdit={isEdit}
          />
        )}
    </>
  );
};
export default SignaturesTable;
